/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from "./routes/__root";
import { Route as IndexRouteImport } from "./routes/index";
import { Route as OwnerIndexRouteImport } from "./routes/owner/index";
import { Route as GuestIndexRouteImport } from "./routes/guest/index";
import { Route as OwnerUnitsIndexRouteImport } from "./routes/owner/units/index";
import { Route as OwnerReservationIndexRouteImport } from "./routes/owner/reservation/index";
import { Route as AdminUnitsIndexRouteImport } from "./routes/admin/units/index";
import { Route as AdminReservationsIndexRouteImport } from "./routes/admin/reservations/index";
import { Route as AdminGuestsIndexRouteImport } from "./routes/admin/guests/index";
import { Route as AdminGateCodesIndexRouteImport } from "./routes/admin/gateCodes/index";
import { Route as OwnerReservationBookRouteImport } from "./routes/owner/reservation/book";
import { Route as AdminUnitsInformationRouteImport } from "./routes/admin/units/information";
import { Route as AdminUnitsCreateRouteImport } from "./routes/admin/units/create";
import { Route as OwnerReservationResIdEditRouteImport } from "./routes/owner/reservation/$resId/edit";
import { Route as AdminUnitsUnitIdEditRouteImport } from "./routes/admin/units/$unitId/edit";
import { Route as AdminUnitsUnitIdCalendarRouteImport } from "./routes/admin/units/$unitId/calendar";

const IndexRoute = IndexRouteImport.update({
  id: "/",
  path: "/",
  getParentRoute: () => rootRouteImport,
} as any);
const OwnerIndexRoute = OwnerIndexRouteImport.update({
  id: "/owner/",
  path: "/owner/",
  getParentRoute: () => rootRouteImport,
} as any);
const GuestIndexRoute = GuestIndexRouteImport.update({
  id: "/guest/",
  path: "/guest/",
  getParentRoute: () => rootRouteImport,
} as any);
const OwnerUnitsIndexRoute = OwnerUnitsIndexRouteImport.update({
  id: "/owner/units/",
  path: "/owner/units/",
  getParentRoute: () => rootRouteImport,
} as any);
const OwnerReservationIndexRoute = OwnerReservationIndexRouteImport.update({
  id: "/owner/reservation/",
  path: "/owner/reservation/",
  getParentRoute: () => rootRouteImport,
} as any);
const AdminUnitsIndexRoute = AdminUnitsIndexRouteImport.update({
  id: "/admin/units/",
  path: "/admin/units/",
  getParentRoute: () => rootRouteImport,
} as any);
const AdminReservationsIndexRoute = AdminReservationsIndexRouteImport.update({
  id: "/admin/reservations/",
  path: "/admin/reservations/",
  getParentRoute: () => rootRouteImport,
} as any);
const AdminGuestsIndexRoute = AdminGuestsIndexRouteImport.update({
  id: "/admin/guests/",
  path: "/admin/guests/",
  getParentRoute: () => rootRouteImport,
} as any);
const AdminGateCodesIndexRoute = AdminGateCodesIndexRouteImport.update({
  id: "/admin/gateCodes/",
  path: "/admin/gateCodes/",
  getParentRoute: () => rootRouteImport,
} as any);
const OwnerReservationBookRoute = OwnerReservationBookRouteImport.update({
  id: "/owner/reservation/book",
  path: "/owner/reservation/book",
  getParentRoute: () => rootRouteImport,
} as any);
const AdminUnitsInformationRoute = AdminUnitsInformationRouteImport.update({
  id: "/admin/units/information",
  path: "/admin/units/information",
  getParentRoute: () => rootRouteImport,
} as any);
const AdminUnitsCreateRoute = AdminUnitsCreateRouteImport.update({
  id: "/admin/units/create",
  path: "/admin/units/create",
  getParentRoute: () => rootRouteImport,
} as any);
const OwnerReservationResIdEditRoute =
  OwnerReservationResIdEditRouteImport.update({
    id: "/owner/reservation/$resId/edit",
    path: "/owner/reservation/$resId/edit",
    getParentRoute: () => rootRouteImport,
  } as any);
const AdminUnitsUnitIdEditRoute = AdminUnitsUnitIdEditRouteImport.update({
  id: "/admin/units/$unitId/edit",
  path: "/admin/units/$unitId/edit",
  getParentRoute: () => rootRouteImport,
} as any);
const AdminUnitsUnitIdCalendarRoute =
  AdminUnitsUnitIdCalendarRouteImport.update({
    id: "/admin/units/$unitId/calendar",
    path: "/admin/units/$unitId/calendar",
    getParentRoute: () => rootRouteImport,
  } as any);

export interface FileRoutesByFullPath {
  "/": typeof IndexRoute;
  "/guest": typeof GuestIndexRoute;
  "/owner": typeof OwnerIndexRoute;
  "/admin/units/create": typeof AdminUnitsCreateRoute;
  "/admin/units/information": typeof AdminUnitsInformationRoute;
  "/owner/reservation/book": typeof OwnerReservationBookRoute;
  "/admin/gateCodes": typeof AdminGateCodesIndexRoute;
  "/admin/guests": typeof AdminGuestsIndexRoute;
  "/admin/reservations": typeof AdminReservationsIndexRoute;
  "/admin/units": typeof AdminUnitsIndexRoute;
  "/owner/reservation": typeof OwnerReservationIndexRoute;
  "/owner/units": typeof OwnerUnitsIndexRoute;
  "/admin/units/$unitId/calendar": typeof AdminUnitsUnitIdCalendarRoute;
  "/admin/units/$unitId/edit": typeof AdminUnitsUnitIdEditRoute;
  "/owner/reservation/$resId/edit": typeof OwnerReservationResIdEditRoute;
}
export interface FileRoutesByTo {
  "/": typeof IndexRoute;
  "/guest": typeof GuestIndexRoute;
  "/owner": typeof OwnerIndexRoute;
  "/admin/units/create": typeof AdminUnitsCreateRoute;
  "/admin/units/information": typeof AdminUnitsInformationRoute;
  "/owner/reservation/book": typeof OwnerReservationBookRoute;
  "/admin/gateCodes": typeof AdminGateCodesIndexRoute;
  "/admin/guests": typeof AdminGuestsIndexRoute;
  "/admin/reservations": typeof AdminReservationsIndexRoute;
  "/admin/units": typeof AdminUnitsIndexRoute;
  "/owner/reservation": typeof OwnerReservationIndexRoute;
  "/owner/units": typeof OwnerUnitsIndexRoute;
  "/admin/units/$unitId/calendar": typeof AdminUnitsUnitIdCalendarRoute;
  "/admin/units/$unitId/edit": typeof AdminUnitsUnitIdEditRoute;
  "/owner/reservation/$resId/edit": typeof OwnerReservationResIdEditRoute;
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport;
  "/": typeof IndexRoute;
  "/guest/": typeof GuestIndexRoute;
  "/owner/": typeof OwnerIndexRoute;
  "/admin/units/create": typeof AdminUnitsCreateRoute;
  "/admin/units/information": typeof AdminUnitsInformationRoute;
  "/owner/reservation/book": typeof OwnerReservationBookRoute;
  "/admin/gateCodes/": typeof AdminGateCodesIndexRoute;
  "/admin/guests/": typeof AdminGuestsIndexRoute;
  "/admin/reservations/": typeof AdminReservationsIndexRoute;
  "/admin/units/": typeof AdminUnitsIndexRoute;
  "/owner/reservation/": typeof OwnerReservationIndexRoute;
  "/owner/units/": typeof OwnerUnitsIndexRoute;
  "/admin/units/$unitId/calendar": typeof AdminUnitsUnitIdCalendarRoute;
  "/admin/units/$unitId/edit": typeof AdminUnitsUnitIdEditRoute;
  "/owner/reservation/$resId/edit": typeof OwnerReservationResIdEditRoute;
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath;
  fullPaths:
    | "/"
    | "/guest"
    | "/owner"
    | "/admin/units/create"
    | "/admin/units/information"
    | "/owner/reservation/book"
    | "/admin/gateCodes"
    | "/admin/guests"
    | "/admin/reservations"
    | "/admin/units"
    | "/owner/reservation"
    | "/owner/units"
    | "/admin/units/$unitId/calendar"
    | "/admin/units/$unitId/edit"
    | "/owner/reservation/$resId/edit";
  fileRoutesByTo: FileRoutesByTo;
  to:
    | "/"
    | "/guest"
    | "/owner"
    | "/admin/units/create"
    | "/admin/units/information"
    | "/owner/reservation/book"
    | "/admin/gateCodes"
    | "/admin/guests"
    | "/admin/reservations"
    | "/admin/units"
    | "/owner/reservation"
    | "/owner/units"
    | "/admin/units/$unitId/calendar"
    | "/admin/units/$unitId/edit"
    | "/owner/reservation/$resId/edit";
  id:
    | "__root__"
    | "/"
    | "/guest/"
    | "/owner/"
    | "/admin/units/create"
    | "/admin/units/information"
    | "/owner/reservation/book"
    | "/admin/gateCodes/"
    | "/admin/guests/"
    | "/admin/reservations/"
    | "/admin/units/"
    | "/owner/reservation/"
    | "/owner/units/"
    | "/admin/units/$unitId/calendar"
    | "/admin/units/$unitId/edit"
    | "/owner/reservation/$resId/edit";
  fileRoutesById: FileRoutesById;
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute;
  GuestIndexRoute: typeof GuestIndexRoute;
  OwnerIndexRoute: typeof OwnerIndexRoute;
  AdminUnitsCreateRoute: typeof AdminUnitsCreateRoute;
  AdminUnitsInformationRoute: typeof AdminUnitsInformationRoute;
  OwnerReservationBookRoute: typeof OwnerReservationBookRoute;
  AdminGateCodesIndexRoute: typeof AdminGateCodesIndexRoute;
  AdminGuestsIndexRoute: typeof AdminGuestsIndexRoute;
  AdminReservationsIndexRoute: typeof AdminReservationsIndexRoute;
  AdminUnitsIndexRoute: typeof AdminUnitsIndexRoute;
  OwnerReservationIndexRoute: typeof OwnerReservationIndexRoute;
  OwnerUnitsIndexRoute: typeof OwnerUnitsIndexRoute;
  AdminUnitsUnitIdCalendarRoute: typeof AdminUnitsUnitIdCalendarRoute;
  AdminUnitsUnitIdEditRoute: typeof AdminUnitsUnitIdEditRoute;
  OwnerReservationResIdEditRoute: typeof OwnerReservationResIdEditRoute;
}

declare module "@tanstack/react-router" {
  interface FileRoutesByPath {
    "/": {
      id: "/";
      path: "/";
      fullPath: "/";
      preLoaderRoute: typeof IndexRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/owner/": {
      id: "/owner/";
      path: "/owner";
      fullPath: "/owner";
      preLoaderRoute: typeof OwnerIndexRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/guest/": {
      id: "/guest/";
      path: "/guest";
      fullPath: "/guest";
      preLoaderRoute: typeof GuestIndexRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/owner/units/": {
      id: "/owner/units/";
      path: "/owner/units";
      fullPath: "/owner/units";
      preLoaderRoute: typeof OwnerUnitsIndexRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/owner/reservation/": {
      id: "/owner/reservation/";
      path: "/owner/reservation";
      fullPath: "/owner/reservation";
      preLoaderRoute: typeof OwnerReservationIndexRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/admin/units/": {
      id: "/admin/units/";
      path: "/admin/units";
      fullPath: "/admin/units";
      preLoaderRoute: typeof AdminUnitsIndexRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/admin/reservations/": {
      id: "/admin/reservations/";
      path: "/admin/reservations";
      fullPath: "/admin/reservations";
      preLoaderRoute: typeof AdminReservationsIndexRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/admin/guests/": {
      id: "/admin/guests/";
      path: "/admin/guests";
      fullPath: "/admin/guests";
      preLoaderRoute: typeof AdminGuestsIndexRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/admin/gateCodes/": {
      id: "/admin/gateCodes/";
      path: "/admin/gateCodes";
      fullPath: "/admin/gateCodes";
      preLoaderRoute: typeof AdminGateCodesIndexRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/owner/reservation/book": {
      id: "/owner/reservation/book";
      path: "/owner/reservation/book";
      fullPath: "/owner/reservation/book";
      preLoaderRoute: typeof OwnerReservationBookRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/admin/units/information": {
      id: "/admin/units/information";
      path: "/admin/units/information";
      fullPath: "/admin/units/information";
      preLoaderRoute: typeof AdminUnitsInformationRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/admin/units/create": {
      id: "/admin/units/create";
      path: "/admin/units/create";
      fullPath: "/admin/units/create";
      preLoaderRoute: typeof AdminUnitsCreateRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/owner/reservation/$resId/edit": {
      id: "/owner/reservation/$resId/edit";
      path: "/owner/reservation/$resId/edit";
      fullPath: "/owner/reservation/$resId/edit";
      preLoaderRoute: typeof OwnerReservationResIdEditRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/admin/units/$unitId/edit": {
      id: "/admin/units/$unitId/edit";
      path: "/admin/units/$unitId/edit";
      fullPath: "/admin/units/$unitId/edit";
      preLoaderRoute: typeof AdminUnitsUnitIdEditRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/admin/units/$unitId/calendar": {
      id: "/admin/units/$unitId/calendar";
      path: "/admin/units/$unitId/calendar";
      fullPath: "/admin/units/$unitId/calendar";
      preLoaderRoute: typeof AdminUnitsUnitIdCalendarRouteImport;
      parentRoute: typeof rootRouteImport;
    };
  }
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  GuestIndexRoute: GuestIndexRoute,
  OwnerIndexRoute: OwnerIndexRoute,
  AdminUnitsCreateRoute: AdminUnitsCreateRoute,
  AdminUnitsInformationRoute: AdminUnitsInformationRoute,
  OwnerReservationBookRoute: OwnerReservationBookRoute,
  AdminGateCodesIndexRoute: AdminGateCodesIndexRoute,
  AdminGuestsIndexRoute: AdminGuestsIndexRoute,
  AdminReservationsIndexRoute: AdminReservationsIndexRoute,
  AdminUnitsIndexRoute: AdminUnitsIndexRoute,
  OwnerReservationIndexRoute: OwnerReservationIndexRoute,
  OwnerUnitsIndexRoute: OwnerUnitsIndexRoute,
  AdminUnitsUnitIdCalendarRoute: AdminUnitsUnitIdCalendarRoute,
  AdminUnitsUnitIdEditRoute: AdminUnitsUnitIdEditRoute,
  OwnerReservationResIdEditRoute: OwnerReservationResIdEditRoute,
};
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>();
